import { Tooltip } from "antd"
import type { TooltipPlacement } from "antd/es/tooltip"
import React from "react"

// UI/UX guidelines §5.16: hover, 300ms, clarification only. Focus is included
// so an icon-only control explains itself to keyboard users too.
export const TOOLTIP_DELAY_SECONDS = 0.3

interface ActionTooltipProps {
  title: React.ReactNode
  placement?: TooltipPlacement
  children: React.ReactNode
  /** Controlled visibility, for a caller that also opens it on tap. */
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

/**
 * Label for an icon-only control. One component so Reports and Home cannot
 * drift apart on delay or placement.
 */
export const ActionTooltip = ({
  title,
  placement = "top",
  children,
  open,
  onOpenChange
}: ActionTooltipProps) => (
  <Tooltip
    title={title}
    placement={placement}
    open={open}
    onOpenChange={onOpenChange}
    mouseEnterDelay={TOOLTIP_DELAY_SECONDS}
    trigger={["hover", "focus"]}
  >
    {children}
  </Tooltip>
)
